import PageHeader from "../PageHeader";
import { ReactComponent as LearnerIcon } from "../../images/learnersimage/learnericon.svg";
import useStyles from "../../../styles";
import ReportHeader from "../../CustomComponent/ReportHeaderNotPreview";
import { Report1Api } from "../../../service/services";
import Loader from "../../CustomComponent/Loader";
import { useState } from "react";
import { ReactComponent as BackIcon } from "../../images/pageheadingicon/backicon.svg";

function CorrectAndIncorrectReport() {
  const classes = useStyles();
  const [loaderOpen, setLoaderOpen] = useState(false);

  const Heading = [
    {
      id: 1,
      pageicon: <LearnerIcon />,
      mainheading: "Correct and Incorrect Report ",
      addbtntext: "Back",
      addbtnicon: <BackIcon />,
      addbtnstyle: "transparentbtn",
      path: "/admin/allreports",
    },
  ];

  return (
    <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
      <Loader loaderOpen={loaderOpen} />
      <PageHeader Heading={Heading} />
      <ReportHeader
        exportApi={Report1Api}
        setLoaderOpen={setLoaderOpen}
        fileName="Correct_and_Incorrect_Report"
      />
    </div>
  );
}
export default CorrectAndIncorrectReport;
